import { useStoreProducts } from "./storeProducts";

function getProductTax(productId) {
  const { products } = useStoreProducts.getState();
  const product = products.get(productId);
  return product?.tax;
}

function computeReverseTax(productId, unit_price_taxed) {
  const productTax = getProductTax(productId);
  const taxed = Number(unit_price_taxed) || 0;
  let unit_price = taxed;
  if (productTax) {
    unit_price = (taxed / (1 + productTax)).toFixed(2);
  }
  return unit_price;
}

export { computeReverseTax, getProductTax };
